export const SET_SETTINGS = 'SET_SETTINGS'
export const SET_SELECTION = 'SET_SELECTION'

export const setSettings = (data) => {
    return async (dispatch) => {
        dispatch({
            type: SET_SETTINGS,
            payload: data
        })
    }
}

export const setSelectionResult = (data) => {
    return async (dispatch) => {
        dispatch({
            type: SET_SELECTION,
            payload: data
        })
    }
}
